import React from 'react';
import {
  Footprints,
  ShieldCheck,
  MapPin,
  Heart,
  CalendarBlank,
  Sun,
} from '@phosphor-icons/react';
import ServicePage from './ServicePage';

const facilities = [
  { icon: ShieldCheck, label: 'Certified walkers', sub: 'Vetted and background-checked' },
  { icon: Footprints, label: 'Breed-aware pacing', sub: 'Calm or active, matched to your dog' },
  { icon: MapPin, label: 'Familiar routes', sub: 'Safe, low-traffic neighbourhood paths' },
  { icon: CalendarBlank, label: 'Flexible timings', sub: 'Morning, evening or both' },
  { icon: Heart, label: 'Soft leash handling', sub: 'Gentle, dog-first technique' },
  { icon: Sun, label: 'Weather-aware', sub: 'Smart route adjustments on hot days' },
];

const gallery = [
  {
    url: 'https://images.pexels.com/photos/7179466/pexels-photo-7179466.jpeg?auto=compress&cs=tinysrgb&w=1600',
    title: 'On the route',
    description: 'Walks paced to your dog’s energy and breed.',
  },
  {
    url: 'https://images.unsplash.com/photo-1601758124510-52d02ddb7cbd?auto=format&fit=crop&w=1200&q=80',
    title: 'Quiet streets',
    description: 'Familiar neighbourhood paths chosen for safety.',
  },
  {
    url: 'https://images.pexels.com/photos/1490908/pexels-photo-1490908.jpeg?auto=compress&cs=tinysrgb&w=1200',
    title: 'Bonding time',
    description: 'Calm one-on-one attention with a trusted walker.',
  },
];

const highlights = [
  'Pickup and drop at your doorstep',
  'Hydration stops on longer walks',
  'Post-walk paw clean before handing back',
  'Walkers trained in basic pet first aid',
];

const DogWalking = () => (
  <ServicePage
    eyebrow="Dog Walking"
    title="Daily walks, expertly managed"
    lede="Trusted walkers, familiar routes and gentle handling — daily exercise your dog actually looks forward to."
    heroImage="https://images.unsplash.com/photo-1548199973-03cce0bbc87b?auto=format&fit=crop&w=2000&q=80"
    heroAlt="Person walking a dog outdoors"
    intro="Every walk is paired to your dog’s personality and energy. Our walkers focus on calm leash technique, social comfort and consistent routes so the experience feels predictable and safe."
    facilities={facilities}
    gallery={gallery}
    highlights={highlights}
    closingTitle="Every walk, an adventure"
    closingBody="From sleepy seniors to high-energy pups, our walkers tailor the pace to each dog — every single time."
  />
);

export default DogWalking;
